/****
 * 遍历取值
 * @returns {Array}
 */
import {getPage, getCtx, getComponent} from '../pages.js';

let current_id = 0;
const createId = () => `${Date.now()}_${++current_id}`;

/***
 * 插入路由
 * @param routes
 */
const insertRoute = (route, routes, num = 0) => {

  if (num > 3) {
    throw '当前层级超过限定值';
    return;
  }

  // 保存当前原始路径
  if (route.n_path === undefined) route.n_path = route.path;

  if (routes.length < 1 || !route.path) {
    route.path = `${route.n_path}${route.params || ''}`;
    routes.push(route);
    return;
  }

  for (let i = 0; i < routes.length; i++) {
    const pPath = routes[i].n_path;
    const p = new RegExp(`^${pPath}`);
    if (p.test(route.n_path)) {
      const p = new RegExp(`^${pPath}`);
      if (!routes[i].children) routes[i].children = [];
      route.n_path = route.n_path.replace(p, '');
      insertRoute(route, routes[i].children, ++num);
      return;
    }
  }
  route.path = `${route.n_path}${route.params || ''}`;
  routes.push(route);
};

const replaceTask = task => {

  if (task instanceof Array) {
    return task.map(replaceTask);
  }

  if (task instanceof Function) return {
    name: `anonymous_${createId()}`,
    handle: task
  };

  if ((typeof task).toLowerCase() === 'string') return {
    name: `dispatch_${task}`,
    handle: dispatch => dispatch(task)
  };

  return task;
};

export default function () {
  const ctx = getCtx();
  const routes = [];
  for (let i = 0; i < ctx.length; i++) {
    const {route, tasks, schedule, validate} = getPage(ctx[i]);

    const path = ctx[i].match(/\.([^.]*)index\.js/, '')[1];
    route.path = path;
    route.schedule = schedule || [];
    route.validate = validate || [];

    route.component = getComponent(ctx[i]);
    const t = (tasks || []).map(replaceTask);
    route.component.tasks = t;
    route.component.schedule = route.schedule;
    route.component.validate = route.validate;
    route.tasks = t;
    insertRoute(route, routes);
  }

  return routes;
}



// WEBPACK FOOTER //
// ./src/router/create.js